export default "__VITE_ASSET__DbY0emkG__"